module.exports = __webpack_public_path__ + "static/media/wand-white.72276f09.svg";